import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sgzp-app2kanri-login',
  templateUrl: './sgzp-app2-kanri-login.component.html',
  styleUrls: ['./sgzp-app2-kanri-login.component.css', '../style/global.css'],
})
export class SgzpApp2KanriLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
